import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CheckCircle, XCircle, AlertCircle } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ModerationResult = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const moderateTestimonial = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/testimonials/moderate/${token}`);
        setResult(response.data);
      } catch (err) {
        setError(err.response?.data?.detail || "Une erreur est survenue");
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      moderateTestimonial();
    }
  }, [token]);

  if (loading) {
    return (
      <div className="moderation-page">
        <div className="moderation-container">
          <div className="loading-spinner"></div>
          <p>Traitement en cours...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="moderation-page">
      <div className="moderation-container">
        {error ? (
          <div className="moderation-result error">
            <XCircle className="result-icon" />
            <h1>Erreur</h1>
            <p>{error}</p>
            <button onClick={() => navigate('/')} className="back-home-btn">
              Retour à l'accueil
            </button>
          </div>
        ) : result?.action === 'approved' ? (
          <div className="moderation-result success">
            <CheckCircle className="result-icon" />
            <h1>Témoignage Approuvé!</h1>
            <p>{result.message}</p>
            <div className="testimonial-preview">
              <h3>👤 {result.testimonial.name}</h3>
              <p>⭐ {result.testimonial.rating}/5</p>
              <p className="comment">"{result.testimonial.comment}"</p>
            </div>
            <button onClick={() => navigate('/')} className="back-home-btn">
              Voir sur le site
            </button>
          </div>
        ) : (
          <div className="moderation-result rejected">
            <AlertCircle className="result-icon" />
            <h1>Témoignage Refusé</h1>
            <p>{result?.message}</p>
            <button onClick={() => navigate('/')} className="back-home-btn">
              Retour à l'accueil
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModerationResult;
